import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class FeaturedThisWeekService {

  constructor(private http:HttpClient) { }

  addFeaturedThisWeek(data) {
    return this.http.post(`${API_URL}featured-this-week`,data);
  }

  updateFeaturedThisWeek(id,data) {
    return this.http.put(`${API_URL}featured-this-week/${id}`,data);
  }

  getFeaturedThisWeekById(id:string) {
    return this.http.get(`${API_URL}featured-this-week/${id}`);
  }

  getFeaturedThisWeek(query:string) {
    return this.http.get(`${API_URL}featured-this-week${query}`);
  }
}
